import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Tooltip from "../../common/StyledToolTip";
import styles from "../headerStyles";
import Button from "@material-ui/core/Button";
import { compose } from "recompose";
import { withAppConfig } from "../../../appConfigContext";
import Notifications from "./Notifications/index";

class RightNavigationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    if (this.props.width === "xl" || this.props.width === "lg") {
      this.props.closeMenu();
    }
  }
  openDynamicRoutingModal = () => {
    if (this.disbaleDynamicRouting) {
      return false;
    }
    this.props.shouldDialogOpen("dispatchOptimization");
  };
  openSetting = (e) => {
    this.props.openSettings(e, "/settings");
    this.props.closeMenu();
  };

  render() {
    const { isDataRefreshProgress, terminalCode, width, classes, openDriverChatBox } = this.props;
    this.disbaleDynamicRouting = isDataRefreshProgress;
    return (
      <div
        className={
          width === "xl" || width === "lg" ? "" : classes.mainMenuStyle
        }
      >
        <div
          className={`${classes.optymizeBtnContainer} ${classes.headerIconStyles}`}
        >
          <Tooltip title="Pickup Optymizer">
            <div
              className={
                this.disbaleDynamicRouting ? classes.disabledCursor : ""
              }
            >
              <Button
                onClick={this.openDynamicRoutingModal}
                variant="contained"
                color="primary"
                size="small"
                style={{ width: "140px" }}
                classes={{
                  root: classes.optymizeButtonStyle,
                  disabled: classes.disabledOptymizeBtn,
                }}
                data-automationid="optimize-button"
              >
                Pickup Optymizer
              </Button>
            </div>
          </Tooltip>
        </div>
        <div
          className={`${classes.terminalIconStyle} ${classes.headerIconStyles}`}
          onClick={this.props.handleTerminalClick}
          data-automationid="terminal-access"
        >
          <Tooltip title={this.props.configJSON.terminalAccessLabel.menuLabel}>
            <span>
              {terminalCode}
              <i
                className="icon-down-dir"
                onClick={this.props.handleTerminalClick}
              />
            </span>
          </Tooltip>
        </div>

        <div
          className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
        >
          <IconButton
            color="inherit"
            className={classes.muiIconButtonStyle}
            onClick={(e) => this.openSetting(e)}
            data-automationid="settings-icon"
          >
            <Tooltip title="Application Settings">
              <SettingsIcon />
            </Tooltip>
          </IconButton>
        </div>
        <Notifications
          switchNotificationPanel={this.props.switchNotificationPanel}
          showNotification={this.props.showNotification}
          openDriverChatBox={openDriverChatBox}
        />
      </div>
    );
  }
}

export default compose(withStyles(styles), withAppConfig)(RightNavigationMenu);
